import { AssetTypeResponse } from 'fireblocks-sdk';

export class PreloadExchangeDto {
  currencies: Array<string>;
  subUsers: Array<any>;
  fireblocksAssets: Array<AssetTypeResponse>;
  fireblocksAccounts: any;
  accounts: any;

}
